import React from 'react';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { TTypedTFunction, useTranslation } from '@lib/useTypedTranslation';

import { Filter } from '../../../../components/timePeriodAndFilterPicker/useFilterPicker';
import { formatDateAsOrdinalWithFullMonthAndYear } from '../../../../lib/ordinal';
import { Theme } from '../../../app/themes';
import { getFilterLabel, getPeriodLabel } from '../../performance/charts/lib';

const Heading = styled.h2`
  margin: 0;
  font-weight: ${({ theme }: { theme: Theme }) => theme.font.weights.bold};
  font-size: ${({ theme }: { theme: Theme }) => theme.font.sizes.sixteenPixels};
`;

interface IHeadingParams {
  filter: Filter,
  days: number,
  timeZone: string,
  /** A local calendar day, 'YYYY-MM-DD' */
  selectedDay?: string,
  t: TTypedTFunction
}

/** "Process crashes for 'filter' in the last x days", or for the selected day: "... for date (time zone)" */
export const getProcessCrashesHeading = ({ filter, days, timeZone, selectedDay, t }: IHeadingParams): string => {
  const filterLabel = getFilterLabel(filter, t);
  if (selectedDay) {
    // The selected day is a calendar date, so is formatted as one rather than converted from an instant in the time zone
    const date = formatDateAsOrdinalWithFullMonthAndYear(moment.utc(selectedDay).valueOf());
    return t('PROCESS_CRASHES_SUBHEADING_DAY', { ns: 'coreProcesses', filter: filterLabel, date, timeZone });
  }
  return t('PROCESS_CRASHES_SUBHEADING', { ns: 'coreProcesses', filter: filterLabel, period: getPeriodLabel(days, t) });
};

export function ProcessCrashesSubheading(props: Omit<IHeadingParams, 't'>) {
  const { t } = useTranslation(['coreProcesses', 'filters', 'timeState']);
  return <Heading data-id="process-crashes-subheading">{getProcessCrashesHeading({ ...props, t })}</Heading>;
}
